<template>
  <ipo3-page>
    <template slot="title">{{title}}</template>
    <template slot="tools">
      <el-button type="primary" @click="goBack" icon="el-icon-back">{{$t('btns.back')}}</el-button>
    </template>
    <template slot="page">
      <div id="home-edit">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="200px"
          class="demo-ruleForm"
        >
          <el-form-item label="繁體標題" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="簡體標題" prop="name_cn">
            <el-input v-model="ruleForm.name_cn"></el-input>
          </el-form-item>
          <el-form-item label="英文標題" prop="name_en">
            <el-input v-model="ruleForm.name_en"></el-input>
          </el-form-item>

          <el-form-item label="繁體內容" prop="content">
            <tinymce :height="142" v-model="ruleForm.content" @on-ready="onReady" ref="tinymce"></tinymce>
          </el-form-item>

          <el-form-item label="簡體內容" prop="content">
            <tinymce :height="142" v-model="ruleForm.content_cn" @on-ready="onCnReady" ref="tinymce_cn"></tinymce>
          </el-form-item>

          <el-form-item label="英文內容" prop="content">
            <tinymce :height="142" v-model="ruleForm.content_en" @on-ready="onEnReady" ref="tinymce_en"></tinymce>
          </el-form-item>
        
          <el-form-item label="是否顯示" prop="status">
            <el-switch v-model="ruleForm.status"></el-switch>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit">提交</el-button>
            <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
          </el-form-item>
        </el-form>
      </div>
    </template>
  </ipo3-page>
</template>
<script>
import tinymce from "@/components/tinymce/index";
export default {
  name: "webpage-edit",
  components: {
    tinymce,
  },
  data() {
    return {
      tableData: [],
      title: '',
      edit: false,
      ruleForm: {
        name: '',
        name_cn: '',
        name_en: '',
        content: '',
        content_cn: '',
        content_en: '',
        status: true,
        id: 0
      }
    };
  },

  created() {
    if (this.$route.params.id !== undefined) {
      this.edit = true;
      this.ruleForm.id = this.$route.params.id;
      this.getData(this.$route.params.id);
    }
  },

  methods: {
    getData(id) {
      var self = this;
      this.$http.get("/admin/webpage/detail", { id: id }).then(res => {
        self.ruleForm = res.data;
        self.ruleForm.status = self.ruleForm.status==1?true:false;
        self.title = res.data.name;
        self.$refs.tinymce.setContent(self.ruleForm.content);
        self.$refs.tinymce_cn.setContent(self.ruleForm.content_cn);
        self.$refs.tinymce_en.setContent(self.ruleForm.content_en);
      });
    },
    onReady() {
      if (this.ruleForm.id > 0) {
        this.$refs.tinymce.setContent(this.ruleForm.content);
      }
    },
    onCnReady() {
      if (this.ruleForm.id > 0) {
        this.$refs.tinymce_cn.setContent(this.ruleForm.content_cn);
      }
    },
    onEnReady() {
      if (this.ruleForm.id > 0) {
        this.$refs.tinymce_en.setContent(this.ruleForm.content_en);
      }
    },
    onSubmit() {
      let params = Object.assign({},this.ruleForm);
      params.status = params.status ? 1 : 0;

      this.$http.post("/admin/webpage/edit", params).then(res => {
        console.log("res:", res);
        this.$message.success("編輯成功");
      });
    },
  }
};
</script>

<style lang="less">
#home-edit {
  width: 800px;
  text-align: left;
}
</style>